import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import useStyles from '../styles';
import ModalBody from '@components/Modals/components/ModalBody';
import ModalBreadcrumb from '@components/Modals/components/ModalBreadcrumb';
import ModalHeader from '@components/Modals/components/ModalHeader';
import ContentCarousel from '@components/UI/ContentCarousel';
import trackHotjarEvent from '@components/Analytics/trackHotjarEvent';
import completePaypalDeposit from '@api/payment/completePaypalDeposit';
import { generateCorrelationId } from '@helpers/correlationId';
import { useFeature } from 'flagged';
import Amount from '@components/Modals/AddFunds/components/BuyCoins/components/Amount';
import PaymentMethod from '@components/Modals/AddFunds/components/PaymentMethod';
import Complete from '@components/Modals/AddFunds/components/Complete';
import TransferConfirmation from '@components/Modals/AddFunds/components/BuyCoins/components/TransferConfirmation';
const BuyCoins = ({ onClose, onNavigateCurrencyStep, onNavigateAmountStep, breadcrumbIndex, setBreadcrumbIndex, transactionAmount, setTransactionAmount, paymentStatus, setPaymentStatus, error, setError, paypalOrderId, setPaypalOrderId, transactionWarningModalData, setTransactionWarningModalData, preSelectedCurrency = false, }) => {
    const { classes } = useStyles();
    const isUsePaymentMicroserviceEnabled = !!useFeature('use_payment_microservice');
    const hideCrumbs = preSelectedCurrency ? [0] : [];
    const handleBalanceTransferRequested = () => {
        setBreadcrumbIndex(3);
    };
    const breadcrumbs = [
        {
            id: '0',
            component: 'Select Currency',
            onClick: () => onNavigateCurrencyStep(),
        },
        {
            id: '1',
            component: 'Amount',
            onClick: () => onNavigateAmountStep(),
        },
        {
            id: '2',
            component: 'Payment Method',
            onClick: () => {
                if (transactionAmount) {
                    setBreadcrumbIndex(3);
                }
            },
        },
    ];
    const handleClose = () => {
        if (paypalOrderId && paymentStatus === 'WAITING') {
            // If the user closed the whole modal when there was a paypal order ID but the state suggests
            // nothing is completed or in process, cancel the payment_order.
            // Best effort - kick it off and ignore any errors.
            void completePaypalDeposit({
                paypalOrderId,
                newOrderState: 'cancelled',
            }, isUsePaymentMicroserviceEnabled, generateCorrelationId());
        }
        onClose();
    };
    const handleCoinSelection = (transactionValue) => {
        setTransactionAmount(transactionValue);
        setBreadcrumbIndex(2);
        trackHotjarEvent(`Click buy/deposit currency`);
    };
    // Called on PayPal success/Error
    const handleFinishProcess = () => {
        // This is pointing to the "Success" step, which does not have a breadcrumb
        setBreadcrumbIndex(4);
    };
    const handleTransferSuccess = () => {
        setPaymentStatus('COMPLETE');
        handleFinishProcess();
        trackHotjarEvent(`Purchases currency success`);
    };
    const handleTransferError = (message) => {
        setPaymentStatus('ERROR');
        setError({ errorMessage: message, allowRetry: true });
        handleFinishProcess();
    };
    const handleTransferCancel = () => {
        setBreadcrumbIndex(2);
    };
    const playMoneyFromUSDMapping = {
        5: 50000,
        10: 100000,
        25: 250000,
        50: 500000,
        100: 1000000,
        500: 5000000,
    };
    return (_jsxs(_Fragment, { children: [_jsx(ModalHeader, { title: "Buy Coins", subtitle: "Add Coins to your account", icon: _jsx("img", { src: "/img/icons/coins.svg", alt: "coins", className: classes.closeButton }), onClose: handleClose, paletteName: "secondary" }), _jsx(ModalBreadcrumb, { currentIndex: breadcrumbIndex, breadcrumbs: breadcrumbs, hideCrumbs: hideCrumbs, isVisible: true }), _jsx(ModalBody, { children: _jsxs(ContentCarousel, { currentStep: breadcrumbIndex - 1, name: "Buy Coins", children: [_jsx(Amount, { onSelect: handleCoinSelection }), _jsx(PaymentMethod, { onFinishProcess: handleFinishProcess, setError: setError, setPaymentStatus: setPaymentStatus, setTransactionWarningModalData: setTransactionWarningModalData, setPaypalOrderId: setPaypalOrderId, paypalOrderId: paypalOrderId, currencyAmount: playMoneyFromUSDMapping[transactionAmount], currency: "PM", transactionAmount: transactionAmount, paymentStatus: paymentStatus, onBalanceTransfer: handleBalanceTransferRequested }), _jsx(TransferConfirmation, { transactionAmount: transactionAmount, onSuccess: handleTransferSuccess, onError: handleTransferError, onCancel: handleTransferCancel }), !transactionWarningModalData.isShow && (_jsx(Complete, { onClose: handleClose, onRetry: () => setBreadcrumbIndex(2), paymentStatus: paymentStatus, currency: "PM", transactionAmount: transactionAmount, currencyAmount: playMoneyFromUSDMapping[transactionAmount], error: error }))] }) })] }));
};
export default BuyCoins;
